import React from 'react';
import EditPackageComponent from '../../../Components/Package/EditPackage';

export default function EditPackage() {
    return (
        <div className='page-body'>
            <EditPackageComponent />
        </div>
    );
}